<template>
    <v-container style="padding: 0 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.AdministracionMagazine') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-dialog v-model="dialog" width="70%" persistent>
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="12" align="center">
                        <h2 class="vietnam display-2 mt-5" v-if="tipoDialog === 'nuevo'">{{ $t('Formularios.NuevoArticulo') }}</h2>
                        <h2 class="vietnam display-2 mt-5" v-if="tipoDialog === 'editar'">{{ $t('Formularios.EditarArticulo') }}</h2>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field persistent-hint solo v-model="tituloEs" :label="$t('Formularios.TituloEs')" :hint="$t('Formularios.TituloEs')" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field persistent-hint solo v-model="tituloEn" :label="$t('Formularios.TituloEn')" :hint="$t('Formularios.TituloEn')" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field persistent-hint solo v-model="enlace" :label="$t('Formularios.EnlacePermanente')" :hint="$t('Formularios.EnlaceHint')" :rules="[reglas.enlace]" />
                        </v-col>
                        <v-col cols="8">
                            <v-autocomplete persistent-hint solo :items="meses" item-text="titulo" item-value="id" v-model="mes" :label="$t('Formularios.Mes')" :hint="$t('Formularios.Mes')" />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field solo v-model="ano" readonly />
                        </v-col>
                        <v-col cols="12">
                          <v-text-field persistent-hint solo v-model="autor" :label="$t('Formularios.Autor')" :hint="$t('Formularios.Autor')" />
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete persistent-hint solo v-model="categoria" :items="categoriasMagazine" item-text="titulo" item-value="id" :label="$t('Formularios.Categoria')" :hint="$t('Formularios.Categoria')" />
                        </v-col>
                        <v-col cols="12">
                            <v-file-input :loading="getCargandoAccion" solo v-model="preImagen" @change="subirPrincipal()" :label="$t('Formularios.ImagenPrincipal')" :hint="$t('Formularios.ImagenPrincipal')"/>
                        </v-col>
                        <v-col cols="12" v-if="imagenPrincipal" align="center">
                          <v-img :src="imagenPrincipal" contain max-height="400" />
                        </v-col>
                        <v-col cols="12">
                            <v-textarea persistent-hint solo v-model="resumenEs" counter="214" :label="$t('Formularios.ResumenEs')" :hint="$t('Formularios.ResumenEs')" />
                        </v-col>
                        <v-col cols="12">
                            <v-textarea persistent-hint solo v-model="resumenEn" counter="214" :label="$t('Formularios.ResumenEn')" :hint="$t('Formularios.ResumenEn')" />
                        </v-col>
                        <v-col cols="12" align="center">
                            <h2 class="my-5 headline vietnam black--text">{{$t('Formularios.ContenidoEs')}}</h2>
                            <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{$t('Formularios.CargandoImagen')}}</v-alert>
                            <vue-editor :customModules="customModulesForEditor" :editorOptions="editorSettings" id="contenidoEs" v-model="contenidoEs" useCustomImageHandler @image-added="handleImageAdded" />
                        </v-col>
                        <v-col cols="12" align="center">
                            <h2 class="my-5 headline vietnam black--text">{{$t('Formularios.ContenidoEn')}}</h2>
                            <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{$t('Formularios.CargandoImagen')}}</v-alert>
                            <vue-editor :customModules="customModulesForEditor" :editorOptions="editorSettings" id="contenidoEn" v-model="contenidoEn" useCustomImageHandler @image-added="handleImageAdded" />
                        </v-col>
                        <v-col cols="12">
                          <v-switch v-model="publicar" inset :label="$t('Formularios.Publicar')" color="error" />
                        </v-col>
                        <v-col cols="12" align="center">
                            <v-btn class="ma-2" outlined style="border: 2px solid" x-large @click="dialog = false">{{$t('Formularios.Cerrar')}}</v-btn>
                            <v-btn class="ma-2" color="primary" x-large @click="publicarArticulo()" v-if="tipoDialog === 'nuevo'">{{$t('Formularios.Guardar')}}</v-btn>
                            <v-btn class="ma-2" color="primary" x-large @click="actualizarArticulo()" v-if="tipoDialog === 'editar'">{{$t('Formularios.Guardar')}}</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="12" align="center">
                <v-btn block color="primary" @click="nuevoArticulo()">{{ $t('Formularios.NuevoArticulo') }}</v-btn>
            </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field solo v-model="buscar" :label="$t('Busqueda.Buscar')"></v-text-field>
            <v-data-table :items="getArticulos" :headers="headerArticulos" :search="buscar">
              <template v-slot:item.acciones="{ item }">
                <v-icon class="mx-2" color="black" @click="verArticulo(item.enlace)">far fa-eye</v-icon>
                <v-icon class="mx-2" color="black" @click="editarArticulo(item)">fas fa-edit</v-icon>
                <v-icon class="mx-2" color="black" @click="abrirDialogEliminar(item.uid)">fas fa-trash</v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-dialog v-model="dialogEliminar" width="60%">
          <v-card>
            <v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="12" align="center">
                    <h2>Estás seguro que deseas eliminar el Artículo</h2>
                    <br>
                    <v-btn class="mx-3" color="primary" large @click="dialogEliminar = false">{{$t('Formularios.Salir')}}</v-btn>
                    <v-btn class="mx-3" color="red white--text" large @click="eliminar()">{{$t('Carrito.Continuar')}}</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
          </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { VueEditor } from 'vue2-editor'
import ImageResize from 'quill-image-resize-module'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'AdministracionMagazine',
  components: {
    VueEditor
  },
  data () {
    return {
      customModulesForEditor: [{ alias: 'imageResize', module: ImageResize }],
      editorSettings: {
        modules: {
          imageResize: {}
        }
      },
      uid: null,
      buscar: null,
      dialog: false,
      tipoDialog: 'nuevo',
      tituloEs: null,
      tituloEn: null,
      enlace: null,
      publicar: true,
      imagenPrincipal: null,
      resumenEs: null,
      resumenEn: null,
      contenidoEs: null,
      contenidoEn: null,
      mes: null,
      ano: moment().format('YYYY'),
      categoria: null,
      preImagen: null,
      autor: null,
      categoriasMagazine: [
        { titulo: this.$i18n.t('Categoria.Invitado'), id: 'Invitado' },
        { titulo: this.$i18n.t('Categoria.Editorial'), id: 'Editorial' },
        { titulo: this.$i18n.t('Categoria.Stories'), id: 'Stories' }
      ],
      meses: [
        { titulo: this.$i18n.t('Mes.Enero'), id: 'Enero' },
        { titulo: this.$i18n.t('Mes.Febrero'), id: 'Febrero' },
        { titulo: this.$i18n.t('Mes.Marzo'), id: 'Marzo' },
        { titulo: this.$i18n.t('Mes.Abril'), id: 'Abril' },
        { titulo: this.$i18n.t('Mes.Mayo'), id: 'Mayo' },
        { titulo: this.$i18n.t('Mes.Junio'), id: 'Junio' },
        { titulo: this.$i18n.t('Mes.Julio'), id: 'Julio' },
        { titulo: this.$i18n.t('Mes.Agosto'), id: 'Agosto' },
        { titulo: this.$i18n.t('Mes.Septiembre'), id: 'Septiembre' },
        { titulo: this.$i18n.t('Mes.Octubre'), id: 'Octubre' },
        { titulo: this.$i18n.t('Mes.Noviembre'), id: 'Noviembre' },
        { titulo: this.$i18n.t('Mes.Diciembre'), id: 'Diciembre' }
      ],
      headerArticulos: [
        { text: 'Titulo', value: 'tituloEs' },
        { text: 'Categoría', value: 'categoria' },
        { text: 'Mes', value: 'mes' },
        { text: 'Año', value: 'ano' },
        { text: 'Acciones', value: 'acciones' }
      ],
      dialogEliminar: false,
      uidEliminar: null,
      reglas: {
        requerido: value => !!value || 'Requerido',
        enlace: value => {
          const pattern = /^[a-zA-Z-]+$/g
          return pattern.test(value) || 'Enlace Inválido'
        }
      }
    }
  },
  mounted () {
    if (!this.getArticulos[0]) {
      var articulos = []
      firebase.firestore().collection('magazine').get().then(response => {
        for (let i = 0; i < response.docs.length; i++) {
          articulos.push(response.docs[i].data())
        }
        this.setArticulos(articulos)
      })
    }
  },
  computed: {
    ...mapGetters(['getArticulos', 'getCargandoAccion', 'getIdioma'])
  },
  methods: {
    ...mapMutations(['setArticulos', 'setCargandoAccion', 'setAlerta', 'setTextoAlerta', 'eliminarArticulo']),
    subirPrincipal () {
      this.setCargandoAccion(true)
      this.subirImagen(this.preImagen).then(url => {
        this.imagenPrincipal = url
        this.setCargandoAccion(false)
      })
    },
    nuevoArticulo () {
      this.dialog = true
      this.tipoDialog = 'nuevo'
    },
    editarArticulo (i) {
      this.uid = i.uid
      this.tituloEs = i.tituloEs
      this.tituloEn = i.tituloEn
      this.enlace = i.enlace
      this.publicar = i.publicar
      this.imagenPrincipal = i.imagenPrincipal
      this.resumenEs = i.resumenEs
      this.resumenEn = i.resumenEn
      this.contenidoEs = i.contenidoEs
      this.contenidoEn = i.contenidoEn
      this.mes = i.mes
      this.ano = i.ano
      this.categoria = i.categoria
      this.autor = i.autor
      this.dialog = true
      this.tipoDialog = 'editar'
    },
    publicarArticulo () {
      const uid = firebase.firestore().collection('magazine').doc().id
      firebase.firestore().collection('magazine').doc(uid).set({
        uid,
        tituloEs: this.tituloEs,
        tituloEn: this.tituloEn,
        enlace: this.enlace.toLowerCase(),
        publicar: this.publicar,
        imagenPrincipal: this.imagenPrincipal,
        resumenEs: this.resumenEs,
        resumenEn: this.resumenEn,
        contenidoEs: this.contenidoEs,
        contenidoEn: this.contenidoEn,
        mes: this.mes,
        ano: this.ano,
        categoria: this.categoria,
        autor: this.autor,
        visitas: 0
      }).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.ArticuloPublicado')
        this.tituloEs = null
        this.tituloEn = null
        this.enlace = null
        this.publicar = true
        this.imagenPrincipal = null
        this.resumenEs = null
        this.resumenEn = null
        this.contenidoEs = null
        this.contenidoEn = null
        this.mes = null
        this.autor = null
        this.categoria = null
        this.dialog = false
      })
    },
    actualizarArticulo () {
      firebase.firestore().collection('magazine').doc(this.uid).update({
        tituloEs: this.tituloEs,
        tituloEn: this.tituloEn,
        enlace: this.enlace.toLowerCase(),
        publicar: this.publicar,
        imagenPrincipal: this.imagenPrincipal,
        resumenEs: this.resumenEs,
        resumenEn: this.resumenEn,
        contenidoEs: this.contenidoEs,
        contenidoEn: this.contenidoEn,
        mes: this.mes,
        ano: this.ano,
        categoria: this.categoria,
        autor: this.autor || ''
      }).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.ArticuloPublicado')
        this.uid = null
        this.tituloEs = null
        this.tituloEn = null
        this.enlace = null
        this.publicar = true
        this.imagenPrincipal = null
        this.resumenEs = null
        this.resumenEn = null
        this.contenidoEs = null
        this.contenidoEn = null
        this.mes = null
        this.autor = null
        this.categoria = null
        this.dialog = false
      })
    },
    verArticulo (enlace) {
      const menu = `${this.$i18n.t('Alias.Articulo')}/${enlace}`
      this.$router.push(menu)
    },
    subirImagen (file) {
      const reader = new FileReader()
      return new Promise(resolve => {
        reader.onload = ev => {
          axios({
            method: 'post',
            url: '/subir',
            crossDomain: true,
            data: {
              image: ev.target.result,
              tipo: 'sinMarca'
            }
          })
            .then(respuesta => {
              fetch(respuesta.data).then(res => res.blob()).then(blob => {
                var uploadTask = firebase.storage().ref('magazine').child(file.name).put(blob)
                uploadTask.on('state_changed', snapshot => {}, error => {
                  console.log(error)
                }, () => {
                  uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                    axios({
                      method: 'post',
                      url: '/eliminar',
                      crossDomain: true,
                      data: {
                        url: respuesta.data
                      }
                    })
                    resolve(downloadURL)
                  })
                })
              })
            })
            .catch(error => {
              console.log(error)
            })
        }
        reader.readAsDataURL(file)
      })
    },
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      this.setCargandoAccion(true)
      this.subirImagen(file).then(url => {
        Editor.insertEmbed(cursorLocation, 'image', url)
        resetUploader()
        this.setCargandoAccion(false)
      })
    },
    abrirDialogEliminar (uid) {
      this.uidEliminar = uid
      this.dialogEliminar = true
    },
    eliminar () {
      firebase.firestore().collection('magazine').doc(this.uidEliminar).delete()
      this.eliminarArticulo(this.uidEliminar)
      this.setAlerta()
      this.setTextoAlerta('Artículo Eliminado con Éxito')
      this.dialogEliminar = false
      this.uidEliminar = null
    }
  }
}
</script>
